import { render, staticRenderFns } from "./UpdatePlayerPreference.vue?vue&type=template&id=fa99d7d0&lang=html&"
import script from "./UpdatePlayerPreference.vue?vue&type=script&lang=js&"
export * from "./UpdatePlayerPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports